import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-xiangshangzhixianjiantou",
  "use": "icon-xiangshangzhixianjiantou-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-xiangshangzhixianjiantou\"><path fill=\"#515151\" d=\"M701.782368 448.208115 510.976694 125.938294 320.169997 448.208115 447.616644 448.208115 447.616644 959.397656 575.785745 959.397656 575.785745 448.208115Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol